<template>
	<div>
		<v-toolbar fixed color="peterBlue" app>
			<v-toolbar-title>
				<div class="headline white--text">404 Page not found</div>
			</v-toolbar-title>
		</v-toolbar>
		<v-content>
			<v-container>
				<div class="text-xs-center mt-3">
					<h1>The page you are looking for doesn't exist.</h1>
					<div class="mt-2"></div>
					<v-btn color="peterBlue" dark large @click="$router.push({name: 'Devices'})">
						Go to Homepage
					</v-btn>
				</div>
			</v-container>
		</v-content>
	</div>
</template>

<script>
	export default {
	    name: 'error'       // you can enter any name (optional)
	}
</script>


// WEBPACK FOOTER //
// src/layouts/error.vue